import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EventTemplate } from '../../../types/EventTemplate';

export const fetchEventTemplate = async (uuid: string | undefined) => {
  if (uuid === undefined) return null;
  
  const response = await CustomAxios.get<EventTemplate>(`event_templates/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetEventTemplateByIdProps {
  uuid?: string;
}
export function useGetEventTemplateById({ uuid }: UseGetEventTemplateByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allEventTemplates, uuid],
    queryFn: () => fetchEventTemplate(uuid)
  });

  return query;
}
